import React from 'react'
import "../assets/styles/Footer-Link-Content.css";

const About = () => {
  return (
    <div className="footer-link-content">
      <h1>ABOUT US</h1>

      <p>Welcome to Mr.Aldrin Ecom's, your premier destination for exquisite jewelry. We take pride in offering a carefully curated collection of fine jewelry pieces that combine elegance, quality, and affordability.</p>

      <section>
        <h2>Our Story</h2>
        <p>Founded with a passion for beautiful jewelry and exceptional customer service, Mr.Aldrin Ecom's has grown from a small local boutique to a trusted online jewelry retailer. Our journey is built on the foundation of providing authentic, high-quality pieces that celebrate life's special moments.</p>
      </section>

      <section>
        <h2>Our Mission</h2>
        <p>We strive to:</p>
        <ul>
          <li>Provide exceptional quality jewelry at competitive prices</li>
          <li>Offer outstanding customer service and support</li>
          <li>Ensure transparency in our business practices</li>
          <li>Create lasting relationships with our customers</li>
        </ul>
      </section>

      <section>
        <h2>Quality Assurance</h2>
        <p>Every piece in our collection undergoes rigorous quality control:</p>
        <ul>
          <li>Careful inspection of materials and craftsmanship</li>
          <li>Authentication of precious stones and metals</li>
          <li>Strict adherence to international quality standards</li>
          <li>Professional packaging to ensure safe delivery</li>
        </ul>
      </section>

      <section>
        <h2>Customer Commitment</h2>
        <p>We believe in putting our customers first through:</p>
        <ul>
          <li>Personalized shopping experience</li>
          <li>Expert guidance and support</li>
          <li>Transparent pricing and policies</li>
          <li>Secure shopping environment</li>
        </ul>
      </section>

      <section>
        <h2>Our Collection</h2>
        <p>Our diverse collection includes:</p>
        <ul>
          <li>Fine jewelry for every occasion</li>
          <li>Contemporary and classic designs</li>
          <li>Customization options</li>
          <li>Seasonal collections and special editions</li>
        </ul>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>We'd love to hear from you! Reach out to us at <a href="mailto:example@gmail.com">example@gmail.com</a> or call us at 9876543210 for any inquiries or assistance.</p>
      </section>
    </div>
  )
}

export default About